import { Link } from 'react-router-dom'
import {
  DashboardOutlined,
  ToolOutlined,
  FileSearchOutlined,
  AppstoreOutlined,
  RocketOutlined,
  ControlOutlined,
  DatabaseOutlined,
  HistoryOutlined,
  AuditOutlined,
  ExclamationCircleOutlined,
  TruckOutlined,
  EnvironmentOutlined,
  SwapOutlined,
  InboxOutlined
} from '@ant-design/icons'

function getItemLayout (label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
    style:
      icon === null
        ? {
            color: '#6C757D',
            fontSize: '11px',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            margin: '16px 0 8px 0',
            cursor: 'default',
            pointerEvents: 'none',
            padding: '0 12px'
          }
        : {
            margin: '2px 0',
            borderRadius: '8px',
            overflow: 'hidden'
          }
  }
}

export const dataUserSiderRoutes = [
  // Sales Coordination Dashboard - Top Level
  getItemLayout(
    <Link to='/sales-coordinator-dashboard'>
      <span style={{ fontWeight: 600 }}>📊 Sales Coordination</span>
    </Link>,
    'sales-coordination-dashboard',
    <ControlOutlined style={{ fontSize: '16px' }} />
  ),
  getItemLayout(
    <Link to='/production-dashboard'>
      <span style={{ fontWeight: 600 }}>Production Dashboard</span>
    </Link>,
    'production-dashboard',
    <DashboardOutlined style={{ fontSize: '16px' }} />
  ),
  getItemLayout(
    <Link to='/production-plans'>
      <span style={{ fontWeight: 600 }}>Production Plans</span>
    </Link>,
    'production-plans',
    <FileSearchOutlined style={{ fontSize: '16px' }} />
  ),
  getItemLayout(
    <Link to='/production-plans-v2'>
      <span style={{ fontWeight: 600 }}>Production Plans V2</span>
    </Link>,
    'production-plans-v2',
    <FileSearchOutlined style={{ fontSize: '16px' }} />
  ),
  getItemLayout(
    <Link to='/smart-production'>
      <span style={{ fontWeight: 600 }}>Smart Production Planner</span>
    </Link>,
    'smart-production',
    <RocketOutlined style={{ fontSize: '16px' }} />
  ),
  getItemLayout(
    <Link to='/job-cards'>
      <span style={{ fontWeight: 600 }}>Job Cards</span>
    </Link>,
    'job-cards',
    <ToolOutlined style={{ fontSize: '16px' }} />
  ),
  getItemLayout(
    <Link to='/production-presets'>
      <span style={{ fontWeight: 600 }}>Preset Management</span>
    </Link>,
    'production-presets',
    <AppstoreOutlined style={{ fontSize: '16px' }} />
  ),
  getItemLayout(
    <Link to='/inventory-requests'>
      <DatabaseOutlined style={{ marginRight: '8px' }} />
      Inventory Requests
    </Link>,
    '6e'
  ),
  getItemLayout(
    <Link to='/dispatch-to-sales'>
      <TruckOutlined style={{ marginRight: '8px' }} />
      Dispatch to Sales
    </Link>,
    'dispatch-to-sales'
  ),
  getItemLayout(
    <Link to='/rejected-stock'>
      <ExclamationCircleOutlined style={{ marginRight: '8px' }} />
      Rejected Stock
    </Link>,
    'rejected-stock'
  ),
  // Inventory System
  getItemLayout('Inventory System', 'inventory-system-menu', <InboxOutlined style={{ fontSize: '16px' }} />, [
    getItemLayout(
      <Link to='/inventory-locations'><EnvironmentOutlined style={{ marginRight: '8px' }} />Inventory Locations</Link>,
      'inventory-locations'
    ),
    getItemLayout(
      <Link to='/inventory-movements'><SwapOutlined style={{ marginRight: '8px' }} />Inventory Movements</Link>,
      'inventory-movements'
    ),
    getItemLayout(
      <Link to='/inventory-management-v2'><DatabaseOutlined style={{ marginRight: '8px' }} />Inventory Management</Link>,
      'inventory-v2'
    )
  ]),

  // Stock Logging System
  getItemLayout(
    <span
      style={{
        fontWeight: 600,
        color: '#6C757D',
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}
    >
      Stock Tracking
    </span>,
    'stock-tracking-divider',
    null,
    []
  ),
  getItemLayout(
    <Link to='/stock-logs'>
      <span style={{ fontWeight: 600 }}>Stock Logs</span>
    </Link>,
    'stock-logs',
    <HistoryOutlined style={{ fontSize: '16px' }} />
  ),
  getItemLayout(
    <Link to='/stock-reconciliation'>
      <span style={{ fontWeight: 600 }}>Stock Reconciliation</span>
    </Link>,
    'stock-reconciliation',
    <AuditOutlined style={{ fontSize: '16px' }} />
  )
]
